import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '62f3ec89fb8c2417d3d11ed4';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
    },
    privacyPolicyUrl: 'https://onewillow.com/privacy-notice/',
};
